import { LoadableAfterPaint } from '@confluence/loadable';

import { WatchButtonPlaceholder } from '../src/WatchButtonPlaceholder.js';

export const WatchDialog = LoadableAfterPaint<any>({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-watch-dialog" */ '../src/WatchDialog.js'))
			.WatchDialog,
	loading: WatchButtonPlaceholder,
});
